export default __webpack_public_path__ + "static/media/DIY.c48de5c1.svg";